import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-one-col-area-button',
  templateUrl: './one-col-area-button.component.html',
  styleUrls: ['./one-col-area-button.component.css']
})
export class OneColAreaButtonComponent implements OnInit {

  @Input() oneColAreaButton_params: any = {}

  constructor() { }

  ngOnInit(): void {
  }

}
